/*
 * @Descripttion:
 * @version:
 * @Author: 苏
 * @email: 1373842098@qq.com
 * @Date: 2022-08-22 13:41:31
 * @LastEditors: linxi
 * @LastEditTime: 2023-03-01 17:27:06
 */
import { unwrapResult } from '@reduxjs/toolkit'
import { Row, Col, Table, Radio, Pagination, Spin } from 'antd'
import React, { ReactElement, useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import {
  ActiveInstitutionsLine,
  HealthCareLine,
  InstitutionsLine,
  LossInstitutionsLine,
  PayAgencyLine,
} from '../../../compnents/icons/Icons'
import {
  getBackgroundColor,
  getOrganizationPlaneName,
} from '../../../models/monitoring'
import { UpdateTime } from '../components/time'
import {
  getActiveInstitutions,
  getAllData,
  getOverviewList,
  getTableList,
  getTendencyChart,
} from '../monitoringPageSlice'
import styles from '../monitoringTab.module.css'
import * as echarts from 'echarts'
import { Query } from './query'
import { Columns, overviewColumns } from './columns'
import { echartsLine, echartsPie } from '../../../models/echartsData'

interface OrganizationDataProps {
  state: string
}

export const OrganizationData = ({
  state,
}: OrganizationDataProps): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const pieRef = useRef<HTMLDivElement>(null)

  const lineRef = useRef<HTMLDivElement>(null)

  const list = [
    {
      name: 'tenantNum',
      title: 'newTenantNum',
      color: 1,
      icon: <InstitutionsLine />,
    },
    {
      name: 'activeTenantNum',
      title: 'newActiveTenantNum',
      color: 2,
      icon: <ActiveInstitutionsLine />,
    },
    {
      name: 'insuranceTenantNum',
      title: 'newInsuranceTenantNum',
      color: 3,
      icon: <HealthCareLine />,
    },
    {
      name: 'newPayTenantNum',
      title: 'newPayTenantNum',
      color: 4,
      icon: <PayAgencyLine />,
    },
    {
      name: 'newLoseTenantNum',
      title: 'newLoseTenantNum',
      color: 5,
      icon: <LossInstitutionsLine />,
    },
  ]

  const [listData, setListData] = useState<any>({})

  const [page, setPage] = useState([]) //各省机构总览 数据

  // const [value, setValue] = useState(0)

  const [dataNum, setDataNum] = useState(0) //全部or好医点or聚网

  const [overviewNum, setOverviewNum] = useState(0) //省or市or区县

  const [pieNum, setPieNum] = useState(0) //分布图or分布表

  const [params, setParams] = useState<any>({
    current: 0,
    size: 10,
  })

  const [tableList, setTableList] = useState<any>({
    total: 0,
    items: [],
  })

  const [pieChartData, setPieChartData] = useState([]) //各省机构分布图数据

  const [lineChartData, setLineChartData] = useState<any>() //近一年机构趋势图数据

  const [pageLoading, setPageLoading] = useState(false) //表格 loading

  const [pageOverviewLoading, setPageOverviewLoading] = useState(false) //表格 loading

  const [listLoading, setListLoading] = useState(false) // 全部、好医点、聚网 loading

  const [distributionLoading, setDistributionLoading] = useState(false) // 各省机构分布表 loading

  const [aaa, setAaa] = useState<number[]>([])

  const getOverviewListFn = () => {
    //省、市、区县 表格数据
    setPageOverviewLoading(true)
    dispatch(
      getOverviewList({
        regionType: overviewNum,
        type: dataNum,
      })
    )
      .then(unwrapResult)
      .then((t: any) => setPage(t))
      .finally(() => setPageOverviewLoading(false))
  }

  const getInstitutionsFigure = () => {
    //各省机构分布图
    setDistributionLoading(true)
    dispatch(getTableList())
      .then(unwrapResult)
      .then((t: any) => setPieChartData(t))
      .finally(() => setDistributionLoading(false))
  }
  const getInstitutionsLineChart = () => {
    //近一年机构趋势图
    dispatch(
      getTendencyChart({
        trendChartType: 0,
        type: dataNum,
      })
    )
      .then(unwrapResult)
      .then((t: any) => setLineChartData(t))
  }

  const getActiveTable = () => {
    //机构活跃数据
    setPageLoading(true)
    dispatch(getActiveInstitutions(params))
      .then(unwrapResult)
      .then((res: any) => {
        setTableList({
          total: res.total,
          items: res.records,
        })
      })
      .finally(() => setPageLoading(false))
  }

  useEffect(() => {
    // 全部、好医点、聚网
    setListLoading(true)
    dispatch(getAllData({ type: dataNum }))
      .then(unwrapResult)
      .then((res: any) => setListData(res))
      .finally(() => setListLoading(false))
    getOverviewListFn()
    getInstitutionsLineChart()
  }, [dataNum])
  useEffect(() => {
    //省、市、区县 表格数据
    getOverviewListFn()
  }, [overviewNum])

  useEffect(() => {
    params.current && getActiveTable()
  }, [params])

  useEffect(() => {
    getInstitutionsFigure()
    getInstitutionsLineChart()
    setParams({
      //获取机构活跃数据
      ...params,
      current: 1,
    })
  }, [])

  useEffect(() => {
    //渲染图表
    setTimeout(() => {
      pieEcharts()
      lineEcharts()
    }, 200)
  }, [pieRef, lineRef, pieChartData, lineChartData])

  useEffect(() => {
    //全省机构分布图
    getInstitutionsFigure()
  }, [pieNum])

  const pieEcharts = () => {
    // 饼状图渲染
    if (!pieRef.current) return
    const myChart = echarts.init(pieRef?.current)
    if (!pieChartData?.length) {
      myChart.dispose()
    }
    myChart.setOption(echartsPie(pieChartData, 'categoryName', 'subCnt'))
  }

  const lineEcharts = () => {
    if (!lineRef.current) return
    const myChart = echarts.init(lineRef?.current)

    myChart.setOption(echartsLine(lineChartData, true, 'organization', 0))
  }

  const sortFn = (str: string) => {
    // 表格排序
    if (!str) return 'cancel'
    if (str == 'ascend') {
      return true
    } else {
      return false
    }
  }

  const onChange = (pagination: any, filters: any, sorter: any, extra: any) => {
    // 表格排序
    if (sorter.columnKey == 'outpatientNumber') {
      //近14天门诊次数
      setParams({
        ...params,
        sort:
          sortFn(sorter.order) == 'cancel'
            ? undefined
            : sortFn(sorter.order)
            ? 0
            : 1,
      })
    } else if (sorter.columnKey == 'settlementNumber') {
      //近14天结算笔数
      setParams({
        ...params,
        sort:
          sortFn(sorter.order) == 'cancel'
            ? undefined
            : sortFn(sorter.order)
            ? 2
            : 3,
      })
    }
  }

  useEffect(() => {
    sessionStorage.setItem(location.pathname, JSON.stringify({ state }))
  }, [state])

  return (
    <div className={styles.containers}>
      <div className={styles.content}>
        <UpdateTime time={listData?.dataTime} select={(v) => setDataNum(v)} />
        <Spin spinning={listLoading}>
          <Row gutter={20} className={styles.planContainer}>
            {list.map((v: any, i: number) => (
              <Col key={v.name} flex={'20%'}>
                <div className={`${styles.planItem} ${styles.layout}`}>
                  <div
                    className={styles.planIcon}
                    style={{ backgroundColor: getBackgroundColor(v.color) }}
                  >
                    {v.icon}
                  </div>
                  <div className={styles.planData}>
                    {getOrganizationPlaneName(v.name)}
                    {listData[v.name] && (
                      <div className={styles.titleWrap}>
                        {/* {`${listData[v.name]}(${listData[v.title]})`} */}
                        <div className={styles.titleText}>
                          {listData[v.name]}
                        </div>
                        <div className={styles.titleText2}>
                          {' '}
                          ({listData[v.title]})
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Spin>
        <Row
          gutter={20}
          className={`${styles.planContainer} ${styles.echartsContainer}`}
        >
          <Col style={{ height: 380, width: '60%' }}>
            <div className={` ${styles.layout}`}>
              <UpdateTime titleType={'f'} select={(v) => setOverviewNum(v)} />
              <Table
                loading={pageOverviewLoading}
                className={styles.table}
                scroll={{ y: 220 }}
                dataSource={page}
                pagination={false}
                columns={overviewColumns()}
              />
            </div>
          </Col>
          <Col style={{ height: 380, width: '39.9%' }}>
            <div className={styles.layout}>
              <UpdateTime titleType={'g'} select={(v) => setPieNum(v)} />
              {pieNum == 0 && (
                <div ref={pieRef} className={styles.echartsPie}></div>
              )}
              {pieNum == 1 && (
                <Table
                  className={styles.table}
                  scroll={{ y: 251 }}
                  dataSource={pieChartData}
                  pagination={false}
                  loading={distributionLoading}
                  columns={[
                    {
                      title: '机构类型',
                      dataIndex: 'categoryName',
                      key: 'categoryName',
                      align: 'center',
                      width: 100,
                    },
                    {
                      title: '机构总数',
                      dataIndex: 'subCnt',
                      key: 'subCnt',
                      align: 'center',
                      width: 100,
                    },
                    {
                      title: '活跃机构数',
                      dataIndex: 'activeCnt',
                      key: 'activeCnt',
                      align: 'center',
                      width: 100,
                    },
                  ]}
                />
              )}
              {/* <div className={styles.action}>
                <Radio.Group options={optionPosition} onChange={(v) => {
                  const value = v.target.value
                  setValue(value)
                }} value={value}
                  optionType="button"
                  buttonStyle="solid"
                />
              </div> */}
            </div>
          </Col>
        </Row>
        <Row gutter={20} className={`${styles.planContainer}`}>
          <Col flex={1}>
            <div className={styles.layout}>
              <div ref={lineRef} className={styles.echartsLine}></div>
            </div>
          </Col>
        </Row>
        <Row className={styles.layout}>
          <Col span={24} style={{ fontSize: 20, fontWeight: 600 }}>
            {getOrganizationPlaneName('i')}
          </Col>
          <Col span={24} style={{ margin: '20px 0 10px 0' }}>
            <Query
              onSubmit={(obj) => {
                setParams({ ...params, ...obj, current: 1 })
              }}
            />
          </Col>

          {/* 表格区域 */}
          <div className={styles.tableWrap} style={{ height: 500 }}>
            <Table
              className={styles.bottomTable}
              scroll={{ y: 445 }}
              dataSource={tableList.items}
              loading={pageLoading}
              columns={Columns((t: any) => {
                console.log(t)
              }, params.size * (params.current - 1))}
              onChange={onChange}
              pagination={false}
            />
          </div>

          <div
            style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'flex-end',
            }}
          >
            <Pagination
              pageSize={params.size}
              current={params.current}
              total={tableList.total}
              onChange={(current, size) => {
                setParams({
                  ...params,
                  size: size as number,
                  current: current,
                })
              }}
              showTotal={(total) => `共 ${total} 条`}
            />
          </div>
        </Row>
      </div>
    </div>
  )
}
